import { AgmInfoWindow } from '@agm/core';
import {
  Component,
  OnInit,
  QueryList,
  ViewChildren
} from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { ApiService } from 'src/app/services/api.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.scss']
})
export class BranchesComponent implements OnInit {
  lat: number = 25.537911020290082;
  lng: number = -103.41543316841125;

  zoom = 13;

  sucursal: any = {
    urlFoto: '../../../assets/img/JU.jpg',
    nombre: 'JUAREZ',
    telefono: '8717328631',
    celularSucursal: '8715995056',
    direccion: 'Av Juarez 3090 Ote, Col Centro, Torreon Coahuila',
    latitud: '',
    longitud: '',
    horario: 'Lunes a Sábado de 8:00am a 9:00pm | Domingos de 10:00am a 9:00pm'
  };

  sucursales: any[] = [];

  @ViewChildren('infoWindow')
  infoWindows!: QueryList<AgmInfoWindow>;

  previousInfoWindow: AgmInfoWindow | null = null;


  constructor(
    private loaderService: LoaderService,
    public cookies: CookieService,
    public apiServices: ApiService,
    public router: Router
  ) { }


  ngOnInit(): void {
    this.getBranches();
  }


  getBranches() {

    this.loaderService.show();

    const data = {
      token: this.cookies.get('Token')
    };

    this.apiServices.getSucursales(data).subscribe({
      next: (value) => {

        this.sucursales = value;

        if (this.sucursales.length > 0) {

          this.sucursal = this.sucursales[0];

          this.lat = this.toNumber(
            this.sucursal.latitud
          );

          this.lng = this.toNumber(
            this.sucursal.longitud
          );
        }

        this.loaderService.hide();
      },

      error: (err) => {
        this.loaderService.hide();
      }
    });
  }


  selectedBranch(
    branch: any,
    infoWindow?: AgmInfoWindow
  ) {

    this.sucursal = branch;

    this.lat = this.toNumber(
      branch.latitud
    );

    this.lng = this.toNumber(
      branch.longitud
    );

    if (infoWindow) {
      this.openInfoWindow(infoWindow);
    }
  }


  isSelectedBranch(branch: any): boolean {

    return this.sucursal?.idSucursal ===
      branch?.idSucursal;
  }


  formatBranchName(name: string): string {

    if (!name) {
      return 'Sucursal';
    }

    return name
      .toLowerCase()
      .replace(/\b\w/g, letter => letter.toUpperCase());
  }


  toNumber(value: any): number {

    const number = Number(value);

    return Number.isFinite(number)
      ? number
      : 0;
  }


  pedirEnSucursal(
    branch: any,
    event: Event
  ) {

    event.stopPropagation();

    this.selectedBranch(branch);

    this.router.navigate(['/store'])
  }


  comoLlegar(
    branch: any,
    event: Event
  ) {

    event.stopPropagation();

    const latitude = this.toNumber(
      branch.latitud
    );

    const longitude = this.toNumber(
      branch.longitud
    );

    if (!latitude || !longitude) {
      return;
    }

    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`,
      '_blank'
    );
  }


  onMapClickEvent(event: any) {
    // No hacemos nada actualmente.
  }


  markerDragEnd(event: any) {
    // No hacemos nada actualmente.
  }


  openInfoWindow(
    infoWindow: AgmInfoWindow
  ) {

    if (this.previousInfoWindow) {
      this.previousInfoWindow.close();
    }

    this.previousInfoWindow = infoWindow;

    infoWindow.open();
  }
}